module.exports = __webpack_public_path__ + "assets/img/jiaoweiduan.3b3fc87c.png";